import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadComponent: () => import('./layout/auth-layout/auth-layout.component').then(m => m.AuthLayoutComponent),
    children: [
      {
        path: 'login',
        loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent)
      },
      {
        path: 'sso-login',
        loadComponent: () => import('./pages/sso-login/sso-login.component').then(m => m.SsoLoginComponent)
      },
      {
        path: 'forgot-password',
        loadComponent: () => import('./pages/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent)
      },
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./layout/app-layout/app-layout.component').then(m => m.AppLayoutComponent),
    canActivate: [authGuard],
    children: [
      {
        path: 'home',
        loadComponent: () => import('./pages/dashboard/home/home.component').then(m => m.HomeComponent)
      },
      {
        path: 'intake',
        loadComponent: () => import('./pages/dashboard/intake/intake.component').then(m => m.IntakeComponent)
      },
      {
        path: 'capacity',
        loadComponent: () => import('./pages/dashboard/capacity/capacity.component').then(m => m.CapacityComponent)
      },
      {
        path: 'operations',
        loadComponent: () => import('./pages/dashboard/operations/operations.component').then(m => m.OperationsComponent)
      },
      {
        path: 'parameterized',
        loadComponent: () => import('./pages/dashboard/parameterized/parameterized.component').then(m => m.ParameterizedComponent)
      },
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: 'sso-login',
    redirectTo: 'auth/sso-login',
    pathMatch: 'full'
  },
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full'
  }
];
